import styled from "styled-components";
import device from "src/constants/media";
import { typography, colors } from "src/theme";

export const Content = styled.div`
  position: relative;
`;
export const DateContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 12px 28px 12px 12px;
  border: 2px solid ${colors.greyVeryLight};
  box-sizing: border-box;
  border-radius: 8px;
  cursor: pointer;
  background: ${colors.white};
  @media ${device.tablet} {
    padding: 20px 36px 20px 20px;
  }
`;
export const CalendarContainer = styled.div`
  width: 40px;
  height: 40px;
`;
export const CalendarText = styled.p`
  margin: 0 71px 0 12px;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.greyDark};
  @media ${device.tablet} {
    margin: 0 26px 0 12px;
    font-size: 24px;
    line-height: 32px;
  }
`;
export const ArrowDown = styled.div`
  width: 12px;
  height: 7px;
  display: flex;
  align-items: center;
`;
export const Container = styled.div`
  position: absolute;
  left: 0;
  top: 76px;
  z-index: 1;
  box-shadow: 0px 8px 64px -32px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  @media ${device.tablet} {
    top: 92px;
  }
`;
